const { formatMoney } = window.BAO.Utils

/**
 * fetch() rejects only for network-level failures - most often because the
 * customer navigated away mid-request, which Safari reports as
 * "TypeError: Load failed". That isn't an application error, so swallow it
 * rather than leave an unhandled rejection for the error tracker to collect.
 *
 * @param {Error} error
 *
 * @returns {null}
 */
function ignoreNetworkFailure (error) {
  // eslint-disable-next-line no-console
  console.warn('Request failed:', error.message)

  return null
}

class GiftCardBalanceChecker extends window.BAO.CustomElement() {
  setupListeners () {
    super.setupListeners()

    const form = this.els.form.element
    const submit = this.els.submit.element

    if (!form || !submit) return

    form.addEventListener('submit', e => e.preventDefault())

    submit.addEventListener('click', e => {
      e.preventDefault()

      if (form.checkValidity()) {
        const formData = Object.fromEntries(new FormData(form))
        this.getGiftCardBalance(formData.email, formData.code)
      } else {
        form.reportValidity()
      }
    })
  }

  async getGiftCardBalance (email, code) {
    const appUrl = this.dataset.appUrl
    const shop = this.dataset.shop

    if (!appUrl || !shop) return

    const params = new URLSearchParams({ shop, code, email })
    const response = await fetch(
      `${appUrl}/api/gift-card-balance?${params}`,
    ).catch(ignoreNetworkFailure)

    if (response == null) return

    const data = await response.json()

    this.els.error.element.ariaHidden = true

    console.info('Gift card balance:', data, data.data)

    if (data.data.errors.length > 0) {
      this.els.total.element.innerHTML = '-'
      this.els.error.element.innerHTML = data.data.errors
        .map(error => `<div>${error.message}</div>`)
        .join('')
      this.els.error.element.ariaHidden = false
    } else {
      this.els.total.element.innerHTML = formatMoney(
        parseInt(data.data.giftCard.balance.amount) * 100,
      )
    }
  }
}

if (!customElements.get('gift-card-balance-checker')) {
  customElements.define('gift-card-balance-checker', GiftCardBalanceChecker)
}
